import axios, {AxiosError, AxiosResponse} from "axios";
import {AdsApiResponse, PaymentMethod} from "../../interface/Server";

// ADS-008
// "Pre-payment
//
// Provide security payment data for transaction
//
//     Endpoint:
//         /ads/donate/prepay
//
// Method:
//     POST
//
// Params:
// {
//     'paymentMethod': 'FirstData - MasterCard'
// }
// 1. FirstData - MasterCard
// 2. FirstData - Visa
//
// Return:
// {
//     'paymentMethod': 'FirstData – MasterCard',
//     'msg': 'OK',
//     'data': {
//     'action': 'https://test.ipg-online.com/connect/gateway/processing',
//         'txntype': 'sale',
//         'timezone': 'Asia/Beijing',
//         'txndatetime': '2019:03:06-11:19:01',
//         'hash_algorithm': 'SHA256',
//         'hash': '',
//         'storename': '10123456789',
//         'mode': 'payonly',
//         'paymentMethod': 'M',
//         'chargetotal': '13.00',
//         'currency': '344',
//         'mobileMode': true,
//         'oid': '20190306113059123123',
//         'responseFailURL': 'https://[hostname]/ads/donate/prepayResponse',
//         'responseSuccessURL': 'https://[hostname]/ads/donate/prepayResponse',
//         'hashExtended': ''
// }
// }
//
// Call:
//     https://test.ipg-online.com/connect/gateway/processing
//
//         Currency Map Table:
//     https://www.currency-iso.org/en/home/tables/table-a1.html"

interface SecurityPaymentDataForTransaction {
    action: 'https://test.ipg-online.com/connect/gateway/processing',
    txntype: 'sale',
    timezone: 'Asia/Beijing',
    txndatetime: '2019:03:06-11:19:01',
    hash_algorithm: 'SHA256',
    hash: '',
    storename: '10123456789',
    mode: 'payonly',
    paymentMethod: 'M',
    chargetotal: '13.00',
    currency: '344',
    mobileMode: true,
    oid: '20190306113059123123',
    responseFailURL: 'https://[hostname]/ads/donate/prepayResponse',
    responseSuccessURL: 'https://[hostname]/ads/donate/prepayResponse',
    hashExtended: ''
}

export const provideSecurityPaymentDataForTransaction = (
    paymentMethod?: PaymentMethod
) => axios.post('/donate/prepay', paymentMethod).then(
    (res: AxiosResponse) => res.data as AdsApiResponse<SecurityPaymentDataForTransaction>
).catch((err: AxiosError) => undefined);
